import type { MySubmission } from '@innspel/core';

/**
 * H3.1 — the two fields the hypothesis module adds to `SubmissionStatusView`
 * (`contracts/models/submission.tsp`): `inTestEvidence` and `conclusionNotices[]`.
 *
 * The portal takes `@innspel/core` from npm, and the version it pins may be older than the
 * contract the server speaks. The core maps nothing — the server's rows pass straight
 * through — so the fields ARE on the row at run time; only the type may lack them. This
 * reader is the one place that says so, and both are optional here for that reason. When
 * the pinned core carries them, the local type goes and the reader stays.
 *
 * Kh6: nothing about the hypothesis is read, because nothing about it arrives — the
 * contract gives the notice's own id, its text and when it was sent, and one boolean.
 */
export interface ConclusionNotice {
  id: string;
  text: string;
  at: string;
}

interface MedGrunnlag {
  inTestEvidence?: boolean;
  conclusionNotices?: ConclusionNotice[];
}

/** `true` while the case is evidence for something the tenant is testing. Never for a queued row. */
export function iGrunnlag(rad: MySubmission): boolean {
  return rad.pending !== true && (rad as MedGrunnlag).inTestEvidence === true;
}

/** The notices on the case, oldest first as the contract delivers them. Empty for a queued row. */
export function notiserAv(rad: MySubmission): ConclusionNotice[] {
  return rad.pending === true ? [] : ((rad as MedGrunnlag).conclusionNotices ?? []);
}
